import { render, staticRenderFns } from "./bread.vue?vue&type=template&id=196db50d&scoped=true"
import script from "./bread.vue?vue&type=script&lang=js"
export * from "./bread.vue?vue&type=script&lang=js"
import style0 from "./bread.vue?vue&type=style&index=0&id=196db50d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196db50d",
  null
  
)

export default component.exports